import type { ResolvedDecimalPrecision } from '@cli-types/core-engine/schema.js'
import { DRIZZLE_DEFAULTS } from '@cli-constants/schema.js'

export function resolveDecimalPrecision(field: {
  precision?: number
  scale?: number
}): ResolvedDecimalPrecision {
  return {
    precision: field.precision ?? DRIZZLE_DEFAULTS.DECIMAL_PRECISION,
    scale: field.scale ?? DRIZZLE_DEFAULTS.DECIMAL_SCALE
  }
}
